import React from 'react';
import styled from 'styled-components';
import { SVGIcon } from '../../BuildingBlocks/SVGIcon';
import { Text } from '../../BuildingBlocks/Text';
import { colors, mixins, media } from '../../css';

const wrapToggleButton = (props) => {
  const { className, selectedIcon, onClick } = props;
  return (
    <button type="button" className={className} onClick={onClick}>
      <SVGIcon selectedIcon={selectedIcon} />
    </button>
  );
};

export const ToggleButton = styled(wrapToggleButton)`
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${colors.colorWhite};
  width: ${mixins.pxToRem(36)};
  height: ${mixins.pxToRem(36)};
  outline: none;

  &:hover {
    cursor: pointer;
    background: ${colors.colorGrey05};
  }

  &:first-of-type {
    margin-right: ${mixins.pxToRem(10)};
  }

  &.active-view {
    border: 1px solid ${colors.colorBlue};
  }
`;

export const ListHeader = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${mixins.pxToRem(34)};

  &.disable-item {
    pointer-events: none;
    opacity: 0.4;
  }
`;

export const SortHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-top: ${mixins.pxToRem(31)};
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const SearchSVG = styled(SVGIcon)`
  top: calc(50% - 10px);
  left: 23px;
  position: absolute;
  pointer-events: none;
  z-index: 3;
`;

export const SearchContainer = styled.div`
  width: 100%;
`;

export const HelpText = styled.div`
  width: 100%;
  margin-top: ${mixins.pxToRem(6)};

  ${media.greaterThan('md')`
  margin-left: ${mixins.pxToRem(60)};
  `};
`;

export const Details = styled(({ children }) => (
  <div>
    <Text.CopyParagraph color="secondary" noMargins>
      {children}
    </Text.CopyParagraph>
  </div>
))`
  padding: 5px 10px;
  color: white;
  width: 100%;
  margin: 5px;
  background-color: ${colors.colorRed};
`;
